import { useFormik } from "formik";
import React from "react";
import { TextInput } from "src/components";
import { useAppSelector } from "src/redux";
import { useAuth } from "src/redux/hooks";
import * as Yup from "yup";
import swal from "sweetalert";

const AccountDetail = () => {
  const { user, updateProfileName, loading } = useAuth();

  const name = user?.name || "";
  const [firstName, lastName] = name.split(" ");
  const initialValues = {
    firstName: firstName,
    lastName: lastName,
  };

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      swal({
        title: `Are you sure to change your name?`,
        icon: "warning",
        buttons: [true, true],
        dangerMode: true,
      }).then(async (willEdit) => {
        if (willEdit) {
          await updateProfileName(
            `${values.firstName} ${values.lastName}`,
            () => {
              swal(`Success! your name has been changed successfully!`, {
                icon: "success",
              });
            },
            (error: string) => {}
          );
        }
      });
    },
  });

  const { errors, touched, getFieldProps, handleSubmit } = formik;

  return (
    <div
      className="tab-pane fade"
      id="account-detail"
      role="tabpanel"
      aria-labelledby="account-detail-tab"
    >
      <div className="card">
        <div className="card-header">
          <h5>Account Details</h5>
        </div>
        <div className="card-body">
          <form noValidate onSubmit={handleSubmit}>
            <div className="row">
              <div className="form-group col-md-6">
                <TextInput
                  label="First Name"
                  {...getFieldProps("firstName")}
                  error={
                    errors.firstName && touched.firstName
                      ? errors.firstName
                      : undefined
                  }
                />
              </div>
              <div className="form-group col-md-6">
                <TextInput
                  label="Last Name"
                  {...getFieldProps("lastName")}
                  error={
                    errors.lastName && touched.lastName
                      ? errors.lastName
                      : undefined
                  }
                />
              </div>
              <div className="form-group col-md-12">
                <label>
                  Phone Number <span className="required">(Can't Change)</span>
                </label>
                <input
                  disabled
                  value={user?.phone}
                  required
                  className="form-control"
                  name="phone"
                  type="text"
                />
              </div>

              <div className="col-md-12">
                <button
                  disabled={loading}
                  type="submit"
                  className="btn btn-fill-out submit font-weight-bold"
                  name="submit"
                  value="Submit"
                >
                  Save Change
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AccountDetail;
